import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-school-info-dialog',
  templateUrl: './school-info-dialog.component.html',
  styleUrls: ['./school-info-dialog.component.scss'],
})
export class SchoolInfoDialogComponent {
  constructor(public dialogRef: MatDialogRef<SchoolInfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
